import { FC } from 'react';
import intl from 'react-intl-universal';
import { tailwindOverride } from '@getsynapse/design-system';
import resourceIcon from 'assets/icons/nav/resource.svg';
interface ResourceButtonProps {
  isExpanded: boolean;
  isActive?: boolean;
  className?: string;
}

const ResourceButton: FC<ResourceButtonProps> = ({
  isExpanded,
  isActive,
  className,
}) => {
  return (
    <div
      className={tailwindOverride(
        'flex items-center h-full gap-x-2 py-2 my-2 rounded cursor-pointer border-light-gray',
        'hover:bg-olive-green hover:bg-opacity-30',
        'focus-within:bg-olive-green focus-within:bg-opacity-60 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-olive-green focus-within:ring-opacity-60',
        className,
        {
          'border-l-2': isActive,
          'bg-olive-green': isActive,
          'bg-opacity-60': isActive,
        }
      )}
    >
      <img
        src={resourceIcon}
        className={tailwindOverride('text-neutral-white h-4 w-4', {
          'mx-auto': !isExpanded,
          'ml-2': isExpanded,
        })}
        alt='icon'
      />
      <span
        className={tailwindOverride(
          'text-label',
          'text-neutral-white',
          'transition-all',
          'duration-75 ease-in',
          'delay-150 motion-safe',
          'inline',
          { hidden: !isExpanded }
        )}
      >
        {intl.get('SIDEBAR.SUPPORT')}
      </span>
    </div>
  );
};

export default ResourceButton;
